import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../apis/store";
import {
  toGetActivities,
  toGetProgramsCategories,
} from "../../../../../apis/actions/programs.actions";
import Selects from "../../../../../biblio/Selects/Selects";
import { Col, ConfigProvider, Row } from "antd";
import YearMonthFilter from "../../../../../biblio/YearMonthFilter";
import DotsLoader from "../../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../../biblio/Pagination/PaginationComponent";
import { getDateRange, scroll } from "../../../../../components/utils/utils";
import ar_EG from "antd/lib/locale/ar_EG";
import OrphansActivitiesList from "./OrphansActivitiesList";
import { getSponsoredOrphans } from "../../../../../apis/actions/sponsor.actions";

const OrphansActivitiesOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const { loading, categories, activities, totalActivitiesPages } = useSelector(
    (state: RootState) => state?.programs
  );
  const { sponsoredOrphans } = useSelector(
    (state: RootState) => state?.sponsor
  );

  const options = sponsoredOrphans?.map((orphan: any) => ({
    id: orphan.id,
    name: `${orphan.firstname} ${orphan.father_name}`,
  }));
  const otpId = useSelector((state: RootState) => state?.recipient?.OtpId);

  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState<string | null>(
    null
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  useEffect(() => {
    dispatch(getSponsoredOrphans({ sponsor_id: otpId }));
    dispatch(toGetProgramsCategories());
  }, [dispatch, otpId]);
  useEffect(() => {
          const { date_from, date_to } = getDateRange(state.year, state.month);
    
    dispatch(
      toGetActivities({
        sponsor_id: otpId,
        limit: itemPerPage,
        page: currentPage,
        category_id: selectedFilter,
        orphan_id: selectedBeneficiary,
        date_from :date_from,
        date_to : date_to
      })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage, selectedBeneficiary, selectedFilter , state]);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
    } else {
      setSelectedFilter(null);
    }
    setCurrentPage(1);
  };
  const handleSelectBeneficiaryChange = (value: any) => {
    if (value) {
      setSelectedBeneficiary(value.value);
    } else {
      setSelectedBeneficiary(null);
    }
    setCurrentPage(1);
  };

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row gutter={8} dir="rtl" style={{ marginBottom: "0.5rem" }}>
          <Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
            <span className="takaful--service-section-title">
              أنشطة أيتامي وأراملي
            </span>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
            <Selects
              options={options}
              selectPlaceholder="المستفيد"
              onChange={handleSelectBeneficiaryChange}
              allowClear={true}
              className="takaful--service-select takaful--request-select"
              popupClassName="takaful--service-select-dropdown"
            />
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
            <Selects
              options={categories}
              selectPlaceholder="صنف البرنامج"
              onChange={handleSelectChange}
              allowClear={true}
              className="takaful--service-select takaful--request-select"
              popupClassName="takaful--service-select-dropdown"
            />
          </Col>
        </Row>

        <YearMonthFilter
          state={state}
          setState={(values) => setState(values)}
        />
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : activities?.length === 0 &&
        !selectedBeneficiary &&
        !selectedFilter ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد أنشطة
        </p>
      ) : activities?.length === 0 &&
        (selectedFilter || selectedBeneficiary || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد أنشطة تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <OrphansActivitiesList requests={activities} />
          </Row>
          <div className="takaful--pagination-container">
            {activities &&
              Math.ceil(totalActivitiesPages * itemPerPage) > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(totalActivitiesPages * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default OrphansActivitiesOverview;
